const DEFAULT_REST_BASE = "https://ws.appclientefiel.com.br/rest/"
const PREPRODUCAO_REST_BASE = "https://preproducao.appclientefiel.com.br/rest/"

const HOSTS_PREPRODUCAO = ["amplify", "painelbeta", "localhost"]

/**
 * URL base dos webservices REST (com barra final em /rest/).
 * Ordem: localStorage "teste" (override manual); host de amplify/painelbeta/localhost → pré-produção; senão produção.
 */
export function getRestApiBaseUrl() {
    try {
        const teste = localStorage.getItem("teste")
        if (teste && String(teste).trim()) return teste
    } catch {
        /* ignore */
    }
    if (typeof window !== "undefined") {
        const href = (window.location.href || "").toLowerCase()
        if (HOSTS_PREPRODUCAO.some((host) => href.includes(host))) return PREPRODUCAO_REST_BASE
    }
    return DEFAULT_REST_BASE
}
